export const ALERT = 'alert';
export const MESSAGE = 'message';
export const SUCCESS = 'success';